module.exports = __webpack_public_path__ + "img/try-test-file.c5a13d31.svg";